"use strict";

window._theme = window._theme || {};

const openNotifyModal = document.querySelectorAll('[data-oos-btn]');
let notifyModal; // Declare notifyModal to track the modal element

openNotifyModal.forEach((el) => {
    el.addEventListener('click', (e) => {
        const productId = e.target.getAttribute('data-pid');
        createAndShowModal(productId);
    });
});

function createAndShowModal(productId) {
    // Check if modal already exists
    if (notifyModal) {
        notifyModal.dataset.productId = productId;
        show();
        return;
    }

    // Create modal HTML
    const modalHTML = `
                <div class="article-notify-me">
                    <div role="dialog" aria-label="Notify me" class="notify-me-modal" data-notify-me-modal="" data-product-id="40192212893829">
                        <div class="notify-modal-overlay">
                            <div class="notify-modal-container">
                                <button class="notify-modal-close" aria-label="Close Modal" data-notify-modal-close="">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                        </path></svg>
                                </button>
                                <div class="notify-modal-body">
                                    <div class="notify-modal-content">
                                        <div class="notify-modal-header">
                                            <h2>WE’RE SORRY! THIS PRODUCT IS CURRENTLY OUT OF STOCK</h2>
                                            <p>Don't worry, we'll restock it soon. Please enter your email to receive a message when it's back in stock.</p>
                                        </div>
                                        <div class="notify-modal-wrapper">
                                            <form>
                                                <div class="notify-modal-form">
                                                    <label class="visually-hidden" for="email">Email:</label>
                                                    <input type="email" name="email" id="email" placeholder="Email" required="" autofocus="">
                                                    <br>

                                                    <button type="submit" class="btn">NOTIFY ME</button>
                                                </div>
                                                <span class="input-error hidden">Invalid Email</span>
                                            </form>
                                            <div class="notify-success hidden" data-notify-success-msg="">Thank you! We will notify you when this product becomes available.</div>
                                        </div>
                                        <div class="notify-modal-footer">
                                            <p>Also, our stores will likely have your favorite fragrance in stock, at the same price as on our site.</p>
                                            <a href="/pages/store-locator" class="btn">FIND IN STORE</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    `;

    // Append modal to the DOM
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    notifyModal = document.querySelector('[data-notify-me-modal]');

    // Add event listeners for the modal
    const closeNotifyModal = notifyModal.querySelector('[data-notify-modal-close]');
    const notifyForm = notifyModal.querySelector("form");
    const notifyEmail = notifyModal.querySelector('input[type="email"]');
    const notifySuccessMsg = notifyModal.querySelector("[data-notify-success-msg]");
    const notifyHeader = notifyModal.querySelector(".notify-modal-header");
    const notifyFooter = notifyModal.querySelector(".notify-modal-footer");
    const errorElem = notifyModal.querySelector(".input-error");

    closeNotifyModal.addEventListener('click', hide);

    notifyForm.addEventListener('submit', (event) => {
        event.preventDefault();
        submit(notifyEmail, errorElem, productId, notifyHeader, notifyFooter, notifyForm, notifySuccessMsg);
    });

    show();
}

function show() {
    notifyModal.style.display = "block";
    document.body.style.overflow = "hidden";
    _theme.focusTrap($(notifyModal), hide);
}

function hide() {
    notifyModal.style.display = "none";
    document.body.style.overflow = "";
    reset();
}

function submit(notifyEmail, errorElem, productId, notifyHeader, notifyFooter, notifyForm, notifySuccessMsg) {
    const emailVal = notifyEmail.value.trim();
    errorElem.classList.add("hidden");

    if (_theme.Helpers.validateEmail(emailVal)) {
        submitDetails(emailVal, productId, "BIS");
        showSuccessMsg(notifyHeader, notifyFooter, notifyForm, notifySuccessMsg);
        setTimeout(hide, 3000);
    } else {
        notifyEmail.focus();
        errorElem.classList.remove("hidden");
    }
}

function submitDetails(emailAddress, productSKU, alertCode) {
    if (window._ltk && emailAddress && productSKU && alertCode) {
        _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
        _ltk.Alerts.Submit();
        _theme.track.trackData({ event: "notifyMeFormSubmitted" });
    }
}

function showSuccessMsg(notifyHeader, notifyFooter, notifyForm, notifySuccessMsg) {
    notifyHeader.classList.add("hidden");
    notifyFooter.classList.add("hidden");
    notifyForm.classList.add("hidden");
    notifySuccessMsg.classList.remove("hidden");
}

function reset() {
    if (notifyModal) {
        const notifyHeader = notifyModal.querySelector(".notify-modal-header");
        const notifyFooter = notifyModal.querySelector(".notify-modal-footer");
        const notifyForm = notifyModal.querySelector("form");
        const notifySuccessMsg = notifyModal.querySelector("[data-notify-success-msg]");
        const notifyEmail = notifyModal.querySelector('input[type="email"]');

        notifyHeader.classList.remove("hidden");
        notifyFooter.classList.remove("hidden");
        notifyForm.classList.remove("hidden");
        notifySuccessMsg.classList.add("hidden");
        notifyEmail.value = '';
    }
}
